module.exports = __webpack_public_path__ + "static/Toast-e52ae1565061f60c35d7fca7335890a6.jpg";